module.exports = __webpack_public_path__ + "static/media/logoNODEJS.55fa39e5.svg";